export const constants = {
  server: 'https://us-central1-acp-illumine-2021.cloudfunctions.net/serverResponse'
}
